module.exports = __webpack_public_path__ + "img/biobank-bg.984b2cf5.png";